import React from 'react';
import { FunctionComponent } from 'react';
import { userSelectors } from '../../../../../../app/resource/user/user.selectors';
import { IUser } from '../../../../../../app/resource/user/user.types';
import { useSelectWithParams } from '../../../../../../utils/selector.utils';
import { Tooltip } from '../../../../../common/Tooltip';
import { IMembersProps } from './types';
import { CircularAvatar } from '../../../CustomAvatar';
import { meetingSimpleSelectors } from '../../../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { isMemberPartOfMeeting, isMemberActiveInWorkspace } from '../../../../../../utils/user.utils';

export const Members: FunctionComponent<IMembersProps> = ({ membersIds, meetingId }) => {
  const members = useSelectWithParams(userSelectors.selectResourcesById, membersIds) as IUser[];
  const meeting = useSelectWithParams(meetingSimpleSelectors.selectResourceById, meetingId ?? '');

  return (
    <div className="group-stack text-right">
      {members.map(
        (member) =>
          member && (
            <Tooltip
              content={`${member.firstName} ${member.lastName}`}
              direction="top"
              bgColor="#13ac92"
              textColor="white"
              key={member.id}
            >
              <span className="btn-badge white-bg f-1" key={`memberId-${member.id}`}>
                <CircularAvatar
                  src={member.image}
                  title={`${member.firstName} ${member.lastName}`}
                  styles={{ verticalAlign: 'baseline' }}
                  classes={
                    (meeting && !isMemberPartOfMeeting(member, meeting)) || !isMemberActiveInWorkspace(member)
                      ? 'deleted-user'
                      : ''
                  }
                />
              </span>
            </Tooltip>
          ),
      )}
    </div>
  );
};
